import { render, staticRenderFns } from "./MarkdownViewer.vue?vue&type=template&id=b8bf72f0&scoped=true&"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js&"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js&"
import style0 from "../../node_modules/github-markdown-css/github-markdown.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bf72f0",
  null
  
)

export default component.exports